import { API, Space, AssetView, ErrorCode } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: Space["id"];
} & Pick<AssetView, "name" | "filters">;

const [useCreateView, createView] = createAsyncAction(
  "views/create",
  async ({ spaceId, name, filters }: Args) => {
    if (!name?.trim())
      throw {
        code: ErrorCode.invalidParams,
        error: "Name is required",
      };
    const res = await API.call<{ view: string }>({
      endpoint: "/views",
      method: "POST",
      data: {
        space_id: spaceId,
        name,
        filters,
      },
    });
    return { ...res, result: res.result.view };
  }
);

export default useCreateView;
export { createView };
